// src/utils/reloadPage.js (Shell)
//
// The one place the shell reloads itself, so tests can mock it (jsdom's location.reload is
// read-only and not implemented).

export function reloadPage() {
    window.location.reload();
}
